<template>
	<el-card class="query-card">
		<!-- 头部 -->
		<div slot="header" class="query-card-header">
			<span>{{ title }}</span>

			<el-button v-if="needMore" type="text" @click="toggle">
				{{ showMore ? $t('roomRenovationManage.hide') : $t('roomRenovationManage.more') }}
			</el-button>
		</div>

		<!-- 基础条件 -->
		<el-row :gutter="20">
			<slot name="base"></slot>

			<!-- 按钮 -->
			<el-col :span="colSpan">
				<el-button type="primary" @click="$emit('search')" icon="el-icon-search">
					{{ $t('accountManage.query') }}
				</el-button>

				<el-button @click="$emit('reset')" style="margin-left: 10px" icon="el-icon-refresh">
					{{ $t('accountManage.reset') }}
				</el-button>
			</el-col>
		</el-row>

		<!-- 更多条件 -->
		<div v-if="needMore" v-show="showMore" class="more-condition">
			<el-row :gutter="20">
				<slot name="more"></slot>
			</el-row>
		</div>
	</el-card>
</template>

<script>
	export default {
		name: 'QueryCard',
		props: {
			title: {
				type: String,
				default: '查询条件',
			},
			colSpan: {
				type: Number,
				default: 6,
			},
		},
		data() {
			return {
				showMore: false,
			};
		},
		computed: {
			baseCount() {
				const slot = this.$slots.more || [];
				return slot.length;
			},
			needMore() {
				return !!this.baseCount;
			},
		},
		methods: {
			toggle() {
				this.showMore = !this.showMore;
			},
		},
	};
</script>

<style scoped lang="scss">
	.query-card {
		margin-bottom: 20px;
	}
	.query-card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.more-condition {
		// margin-top: 20px;
	}

	:deep(.el-col) {
		margin-bottom: 20px;
	}
</style>
